<template>
  <div class="entry-info-more">
    <div class="title-info" v-if="project.unionMatchId">
      <div class="h1">{{ match.chineseName }}</div>
      <div class="h2">{{ project.matchGroupName }}</div>
      <div class="item">
        允许队员人数：{{ project.teamMemberLeastCount }} ～ {{ project.teamMemberLimitCount }}
      </div>
      <div class="item" v-if="project.genderLimit !== 3">
        允许性别：{{ project.genderLimit === 1 ? '男' : project.genderLimit === 2 ? '女' : '混合' }}
      </div>
      <div class="item" v-if="project.isOpenAgeLimit === 1">
        参赛年龄：{{ getFormatDate(project.maxAge) }}
        {{ project.maxAge && project.minAge ? '~' : '' }}
        {{ getFormatDate(project.minAge) }}
      </div>
      <div class="item" v-if="project.feeMethod !== 0">
        收费方式：{{ getFeeMethodsLabel(project.feeMethod) }}
      </div>
       <div class="item" v-if="project.feeMethod !== 0">
        收费说明：{{ project.feeDescription }}
      </div>
      <div class="price" v-if="project.feeMethod !== 0">
        ¥
        <span>
          {{ project.feeAmount ? (project.feeAmount / 100).toFixed(2) : '0.00' }}
        </span>
        {{ project.feeMethod === 1 ? '人' : '队' }}
      </div>
    </div>
    <div class="player-list">
      <div class="notice">
        <img src="../../../assets/notice.png" alt="" style="width: 20px;; height: 20px;">
        {{ getFormatDate(match.regUpdateEndDate) }} 前，您仍然可以通过“我的参赛”列表进入继续修改参赛名单
      </div>
      <div style="height: 12px; background-color: #F6F6F8;"></div>
      <div class="players">
        <van-swipe-cell v-for="(item, index) in players" :key="index">
          <div class="player" @click="showPlayerFun(item, index)">
            <div v-if="item.showPlayerInfo">
              <div class="row">
                <div class="left">
                  <div class="index">{{ index + 1 }} / {{ project.teamMemberLimitCount }}</div>
                  <div class="true-name">{{ item.trueName }}</div>
                  <div v-if="item.gender === '1'" style="margin-right: 6px">
                    <img src="../../../assets/boy.png" style="width: 20px; height: 20px;">
                  </div>
                  <div v-else-if="item.gender === '0'" style="margin-right: 6px">
                    <img src="../../../assets/girl.png" style="width: 20px; height: 20px;">
                  </div>
                </div>
                <img src="../../../assets/right.png" alt="" style="width: 16px; height: 16px;">
              </div>
              <div class="row" style="margin-top: 18px">
                <div class="left">
                  <span class="info">出生日期：</span>
                </div>
                <div>
                  <span class="info">
                    {{ getFormatDate(item.bmBirthday) }} {{ getAge(item.bmBirthday) }}
                  </span>
                </div>
              </div>
              <div class="row" style="margin-top: 8px">
                <div class="left">
                  <span class="info">身份证&nbsp;&nbsp;&nbsp;&nbsp;：</span>
                </div>
                <div v-if="item.IDCardNo">
                  <span class="info">{{ item.IDCardNo.slice(0, 6) + ' **** **** **' +
                    item.IDCardNo.slice(item.IDCardNo.length - 2) }}</span>
                </div>
              </div>
            </div>
            <div v-else>
              <div class="row">
                <div class="left">
                  <div class="index">{{ index + 1 }} / {{ project.teamMemberLimitCount }}</div>
                  <div class="true-name">等待加入</div>
                  <div
                    style="color: #07C15E; background-color: rgba(7, 193, 94, 0.1); width: 20px; height: 20px; display: flex; justify-content: center; align-items: center">
                    ?</div>
                </div>
                <img src="../../../assets/right.png" alt="" style="width: 16px; height: 16px;">
              </div>
              <div class="row" style="margin-top: 18px">
                <div class="left">
                  <span class="info">出生日期：</span>
                </div>
                <div>
                  <span class="info">
                    --
                  </span>
                </div>
              </div>
              <div class="row" style="margin-top: 8px">
                <div class="left">
                  <span class="info">身份证&nbsp;&nbsp;&nbsp;&nbsp;：</span>
                </div>
                <div>
                  <span class="info">
                    --
                  </span>
                </div>
              </div>
            </div>
          </div>
          <template #right>
            <van-button @click="deletePlayer(index)" square text="删除" type="danger" class="delete-button" />
          </template>
        </van-swipe-cell>
      </div>
    </div>
    <div style="height: 120px;"></div>
    <div v-if="showButton">
      <div class="bottom" v-if="!teamId">
        <div @click="showAgreementFun(item)" v-if="project.isUseAgreement === 1 && agreementList.length > 0"
          style="display: flex; justify-content: center; padding: 0 0 8px 0">
          <van-checkbox disabled v-model="allow" shape="square" icon-size="16px">
            <span style="font-size: 13px; color: #8C8C8C">报名前请先同意</span>
            <span v-for="item in agreementList" :key="item.id" style="color: #409EFF; font-size: 13px;">《{{ item.title
            }}》</span>
          </van-checkbox>
        </div>
        <van-button type="info" round block @click="savePlayers" style="height: 50px; background-color: #191919;">
          <span style="color: #FFFFFF;">保 存</span>
        </van-button>
      </div>
      <div class="bottom" v-else>
        <van-button type="info" round block @click="updatePlayers" style="height: 50px; background-color: #191919;">
          <span style="color: #FFFFFF;">更 新</span>
        </van-button>
      </div>
    </div>
    <div class="popup">
      <van-popup class="player-popup" v-model="showPlayer" position="bottom" :style="{ height: '80%' }" round>
        <div style="padding-top: 12px; font-size: 18px; color: #191919; text-align: center">队员添加/编辑</div>
        <van-form ref="playerForm" input-align="right" error-message-align="right">
          <div class="title">
            <div class="icon"></div>
            <span>队员信息</span>
          </div>
          <van-field :label="getLabel('trueName')" v-model="player.trueName" placeholder="请输入名称"
            :rules="[{ required: true, message: '请输入名称' }]"></van-field>
          <van-field v-if="playerCheckboxes.IDCard" label="证件类型" v-model="player.certTypeValue" placeholder="请选择证件类型"
            readonly clickable @click="showCertTypeFun" :rules="[{ required: true, message: '请选择证件类型' }]"></van-field>
          <van-field v-if="playerCheckboxes.IDCard" label="证件号码" v-model="player.IDCardNo" placeholder="请输入证件号码"
            :rules="[{ required: true, message: '请输入证件号码' }, { validator: checkIDCardNo, message: '请输入正确的证件号码' }]"></van-field>
          <van-field v-if="playerCheckboxes.mobile" label="联系电话" v-model="player.mobile" placeholder="请输入联系电话"
            :rules="[{ required: true, message: '请输入联系电话' }, { validator: checkMobile, message: '请输入正确的联系电话' }]"></van-field>
          <van-field v-if="playerCheckboxes.gender" label="性别" v-model="player.gender"
            :rules="[{ required: true, message: '请选择证件类型' }]">
            <template #input>
              <van-radio-group v-model="player.gender" direction="horizontal">
                <van-radio name="1" checked-color="#FF6010" icon-size="16px"
                  :disabled="checkIDCardNoDis(player.IDCardNo)">男</van-radio>
                <van-radio name="2" checked-color="#FF6010" icon-size="16px"
                  :disabled="checkIDCardNoDis(player.IDCardNo)">女</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field v-if="playerCheckboxes.bmBirthday" :label="getLabel('bmBirthday')" v-model="player.bmBirthdayValue"
            placeholder="请选择出生年月" readonly clickable @click="showBirthdayFun"
            :rules="[{ required: true, message: '请选择出生年月' }]"></van-field>
          <van-field v-if="playerCheckboxes.avatar" label="报名照" :rules="[{ required: true, message: '请上传报名照' }]">
            <template #input>
              <van-uploader v-model="player.avatarList" max-count="1" :after-read="uploadAvatar" @delete="deleteAvatar" />
            </template>
          </van-field>
          <van-field v-if="playerCheckboxes.nationality" label="国籍" v-model="player.nationality" placeholder="请输入国籍"
            :rules="[{ required: true, message: '请输入国籍' }]"></van-field>
          <van-field v-if="playerCheckboxes.IDCardPhotoA" label="身份证/护照正面"
            :rules="[{ required: true, message: '请上传身份证/护照正面' }]">
            <template #input>
              <van-uploader v-model="player.IDCardPhotoAList" max-count="1" :after-read="uploadIDCardPhotoA"
                @delete="deleteIDCardPhotoA" />
            </template>
          </van-field>
          <van-field v-if="playerCheckboxes.IDCardPhotoB" label="身份证/护照背面"
            :rules="[{ required: true, message: '请上传身份证/护照背面' }]">
            <template #input>
              <van-uploader v-model="player.IDCardPhotoBList" max-count="1" :after-read="uploadIDCardPhotoB"
                @delete="deleteIDCardPhotoB" />
            </template>
          </van-field>
          <van-field v-if="playerCheckboxes.number" label="球衣号码" v-model="player.number" placeholder="请输入球衣号码"
            :rules="[{ required: true, message: '请输入球衣号码' }]"></van-field>
          <van-field v-if="playerCheckboxes.position" label="场上位置" v-model="player.position" placeholder="请输入场上位置"
            :rules="[{ required: true, message: '请输入场上位置' }]"></van-field>
          <van-field v-if="playerCheckboxes.emergencyContactName" label="紧急联系人" v-model="player.emergencyContactName"
            placeholder="请输入紧急联系人" :rules="[{ required: true, message: '请输入紧急联系人' }]"></van-field>
          <van-field v-if="playerCheckboxes.isProfessionalPlayer" label="是否职业球员" v-model="player.isProfessionalPlayer"
            :rules="[{ required: true, message: '请选择是否是职业球员' }]">
            <template #input>
              <van-radio-group v-model="player.isProfessionalPlayer" direction="horizontal">
                <van-radio name="0" checked-color="#FF6010" icon-size="16px">否</van-radio>
                <van-radio name="1" checked-color="#FF6010" icon-size="16px">是</van-radio>
              </van-radio-group>
            </template>
          </van-field>
          <van-field v-if="playerCheckboxes.high" label="身高" v-model="player.high" placeholder="请输入身高（CM）"
            :rules="[{ required: true, message: '请输入身高（CM）' }]"></van-field>
          <van-field v-if="playerCheckboxes.weight" label="体重" v-model="player.weight" placeholder="请输入体重（KG）"
            :rules="[{ required: true, message: '请输入体重（KG）' }]"></van-field>
          <van-field v-if="playerCheckboxes.bmEmail" label="邮箱地址" v-model="player.bmEmail" placeholder="请输入邮箱地址"
            :rules="[{ required: true, message: '请输入邮箱地址' }]"></van-field>
          <van-field v-if="playerCheckboxes.jerseyName" label="球衣姓名" v-model="player.jerseyName" placeholder="请输入球衣姓名"
            :rules="[{ required: true, message: '请输入球衣姓名' }]"></van-field>
          <!-- <van-field v-if="playerCheckboxes.jerseysSize" label="球衣尺码" v-model="player.jerseysSize"
                     placeholder="请输入球衣尺码" :rules="[{ required: true, message: '请输入球衣尺码' }]"></van-field> -->
          <JerseySize v-if="playerCheckboxes.jerseysSize" :card="jerseysSizeObj.card" :arr="jerseysSizeObj.arr"
            :text="player.jerseysSize" @update="(e) => player.jerseysSize = e" />
          <van-field v-if="playerCheckboxes.shoesSize" label="球鞋尺码" v-model="player.shoesSize" placeholder="请输入球鞋尺码"
            :rules="[{ required: true, message: '请输入球鞋尺码' }]"></van-field>
          <van-field v-if="playerCheckboxes.qualificationFile" label="资质证明"
            :rules="[{ required: true, message: '请上传资质证明' }]" input-align="left" style="display: block;">
            <template #input>
              <div class="my-imgs">
                <div style="font-size: 12px;margin-bottom: 6px;">最多上传5张图片</div>
                <div style="padding-left: 12px;">
                  <van-uploader v-model="player.qualificationFileList" max-count="5" :after-read="uploadQualificationFile"
                    @delete="deleteQualificationFile" />
                </div>
              </div>
            </template>
          </van-field>
          <van-field v-if="playerCheckboxes.insureFile" label="保险证明" :rules="[{ required: true, message: '请上传保险证明' }]">
            <template #input>
              <van-uploader v-model="player.insureFileList" max-count="1" :after-read="uploadInsureFile"
                @delete="deleteInsureFile" />
            </template>
          </van-field>
          <van-field v-if="playerCheckboxes.school" label="就读学校" v-model="player.school" placeholder="请输入就读学校"
            :rules="[{ required: true, message: '请输入就读学校' }]"></van-field>
          <van-field v-if="playerCheckboxes.remark" label="备注" v-model="player.remark" placeholder="请输入备注"
            :rules="[{ required: true, message: '请输入备注' }]"></van-field>
          <van-field v-if="playerCheckboxes.domicileAreaId" label="所属城市" v-model="player.domicileAreaName" readonly
            @click="showArea = true" placeholder="请选择所属城市" :rules="[{ required: true, message: '请选择所属城市' }]"></van-field>
          <van-field v-if="playerCheckboxes.ethnicity" label="民族" v-model="player.ethnicity" placeholder="请输入民族"
            :rules="[{ required: true, message: '请输入民族' }]"></van-field>
          <van-field v-if="playerCheckboxes.title" label="队内职务" v-model="player.title" placeholder="请输入队内职务"
            :rules="[{ required: true, message: '请输入队内职务' }]"></van-field>
          <van-field v-if="playerCheckboxes.enterprise" label="工作单位" v-model="player.enterprise" placeholder="请输入工作单位"
            :rules="[{ required: true, message: '请输入工作单位' }]"></van-field>
          <van-field v-if="playerCheckboxes.post" label="岗位" v-model="player.post" placeholder="请输入岗位"
            :rules="[{ required: true, message: '请输入岗位' }]"></van-field>
          <van-field v-if="playerCheckboxes.guardianName" label="家长姓名" v-model="player.guardianName" placeholder="请输入家长姓名"
            :rules="[{ required: true, message: '请输入家长姓名' }]"></van-field>
          <van-field v-if="playerCheckboxes.guardianMobile" label="家长手机号" v-model="player.guardianMobile"
            placeholder="请输入家长手机号" :rules="[{ required: true, message: '请输入家长手机号' }]"></van-field>
          <van-field v-if="playerCheckboxes.joinTeam" label="所属球队" v-model="player.joinTeam" placeholder="请输入所属球队"
            :rules="[{ required: true, message: '请输入所属球队' }]"></van-field>
        </van-form>
        <div style="height: 80px;"></div>
        <div class="bottom" v-if="showButton">
          <van-button type="info" round block @click="savePlayer" style="height: 50px; background-color: #191919;">
            <span style="color: #FFFFFF;">保 存</span>
          </van-button>
        </div>
      </van-popup>
      <van-popup v-model="showBirthday" position="bottom" :style="{ height: '50%' }">
        <van-datetime-picker v-model="currentDate" type="date" title="选择年月日" :min-date="minDate" :max-date="maxDate"
          @cancel="cancelBirthdayTime" @confirm="confirmBirthdayTime" />
      </van-popup>
      <van-popup v-model="showCertType" position="bottom" :style="{ height: '50%' }">
        <van-picker title="请选择证件类型" show-toolbar :columns="certTypeColumns" @confirm="onConfirmCertType"
          @cancel="onCancelCertType" :default-index="defaultCertIndex" />
      </van-popup>
      <van-popup v-model="showArea" round position="bottom">
        <van-cascader v-model="player.domicileAreaId" title="请选择所在地区" :options="options" :field-names="fieldNames"
          @close="showArea = false" @change="onChange" @finish="onFinish" />
      </van-popup>
      <van-popup v-model="showAgreement" position="bottom" round :style="{ height: '70%' }">
        <div id="agreement"></div>
        <div style="height: 115px;"></div>
        <div class="bottom">
          <van-button type="info" block @click="allowAgreement"
            style="background-color: #191919; color: #FFFFFF; height: 50px; border-radius: 25px">同意条款</van-button>
        </div>
      </van-popup>
    </div>
    <van-overlay :show="showLoading">
      <div class="wrapper">
        <van-loading color="#1989fa" size="30" />
      </div>
    </van-overlay>
    <van-dialog v-model="showDialog" title="提交成功" @confirm="goEntryList" confirm-button-text="我的参赛" theme="round-button"
      confirm-button-color="darkblue">
      <div style="font-size: 13px; color: #333333; padding: 12px 20px 10px 20px">
        <span style="display: inline-block; font-size: 13px; width: 2em;"></span>
        提交成功，您可以前往"我的参赛列表"查看报名进度
      </div>
    </van-dialog>
    <van-popup v-model="signupInstructionsOpen" :close-on-click-overlay="false"
      :style="{ width: '80%', 'border-radius': '4px' }">
      <div class="notice">
        <div class="notice-title">报名须知</div>
        <div class="info" v-html="signupInstructions"></div>
        <div class="close" :class="{ 'disabled': time > 0 }" @click="closeNotice">
          我知道了 <span v-if="time > 0">({{ time }})</span>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Vue from 'vue'
import {
  Tab, Tabs, Form, Field, Icon, Popup, Cascader,
  Checkbox, Loading, Overlay, Dialog, Uploader,
  Toast, RadioGroup, Radio, DatetimePicker, SwipeCell, Button, Picker
} from 'vant'
import { DateUtil, QNImageUtil, RegExpr, ToolUtil } from '@/utils'
import { getQiniuUploadToken, uploadImage } from '@/api/qiniu'
import {
  createBMMatchGroupTeam, getAreaTreeList,
  getBMMatchTeamSignup,
  getBMUnionMatch, updateBMMatchGroupTeam,
} from "@/api/match";
import { getPassport } from "@/libs/passport";
import { feeMethodOptions } from "@/config";
import JerseySize from '@/components/JerseySize'
import Cookies from 'js-cookie'
Vue.use(Tab).use(Tabs).use(Form).use(Field).use(Icon).use(Popup).use(Checkbox)
  .use(Loading).use(Overlay).use(Dialog).use(Uploader).use(RadioGroup).use(Radio).use(Button)
  .use(DatetimePicker).use(SwipeCell).use(Picker).use(Cascader)

const certTypeColumns = ['身份证', '护照', '港澳通行证', '台胞证', '港澳台回乡证']

const certTypeOption = [
  { value: 1, label: '身份证' },
  { value: 2, label: '护照' },
  { value: 3, label: '港澳通行证' },
  { value: 4, label: '台胞证' },
  { value: 5, label: '港澳台回乡证' }
]

export default {
  components: {
    JerseySize
  },
  data() {
    return {
      certTypeColumns: certTypeColumns,
      unionMatchId: '',
      match: {},
      projectId: '',
      teamId: '',
      project: {},
      players: [],
      player: { certType: 1 },
      index: '',
      type: '',
      showPlayer: false,
      allow: false,
      showLoading: false,
      showDialog: false,
      qiniuToken: '',
      showBirthday: false,
      minDate: '',
      maxDate: '',
      currentDate: '',
      defaultIndex: 0,
      showCertType: false,
      defaultCertIndex: 0,
      shareShow: false,
      options: [],
      fieldNames: {
        text: 'name',
        value: 'id',
        children: 'kids',
      },
      showArea: false,
      playerCheckboxes: {},
      agreementList: [],
      showAgreement: false,
      title: '',
      jerseysSizeObj: {},
      showButton: false,
      signupInstructionsOpen: false,
      time: 5,
      signupInstructions: '',
      playerSignupFieldsLabel: {
        trueName: '姓名',
        bmBirthday: '出生日期'
      }
    }
  },
  watch: {
    'player.IDCardNo': {
      handler() {
        if (RegExpr.isIdCard(this.player.IDCardNo)) {
          const player = JSON.parse(JSON.stringify(this.player))
          player.gender = '' + ToolUtil.getSex(player.IDCardNo)
          player.bmBirthdayValue = ToolUtil.getBirthday(player.IDCardNo)
          player.bmBirthday = DateUtil.parseDateTime(ToolUtil.getBirthday(player.IDCardNo), '{y}-{m}-{d}T00:00:00+0800')
          this.player = player
        }
      }
    },
    'player.gender': {
      handler() {
        if (this.playerCheckboxes.gender && (this.project.genderLimit != 0 && this.project.genderLimit != 3) && this.player.gender != this.project.genderLimit) {
          Toast({ type: 'fail', message: '性别异常' })
        }
      }
    }
  },
  mounted() {
    getPassport().then(res => {
      if (res) {
        this.unionMatchId = this.$route.query.unionMatchId
        this.projectId = this.$route.query.matchId
        this.teamId = this.$route.query.teamId || ''
        this.getBMUnionMatch()
        this.getQiniuUploadToken()
        this.getAreaTreeList()
      }
    })
  },
  methods: {
    getLabel(type) {
      const label = this.playerSignupFieldsLabel[type]
      return label
    },
    closeNotice() {
      if (this.time <= 0) {
        this.signupInstructionsOpen = false
        Cookies.set(this.teamId, this.teamId)
      }
    },
    getFeeMethodsLabel(value) {
      const item = feeMethodOptions.find(f => f.value === value)
      if (!item) return '--'
      return item.label
    },
    checkIDCardNoDis(value) {
      return RegExpr.isIdCard(value)
    },
    showBirthdayFun() {
      if (RegExpr.isIdCard(this.player.IDCardNo)) return
      this.showBirthday = true
    },
    allowAgreement() {
      this.allow = true
      this.showAgreement = false
    },
    showAgreementFun() {
      this.showAgreement = true
      setTimeout(() => {
        const agreement = document.getElementById('agreement')
        let inner = ''
        this.agreementList.forEach(a => {
          inner += `<div style="background-color: #fff; padding: 12px 12px 0 12px;text-align: center;font-weight: 600;font-size: 24px;margin-bottom: 4px;">${a.title}</div>`
          inner += a.content
        })
        agreement.innerHTML = inner
      }, 0)
    },
    onChange({ selectedOptions }) {
      const a = []
      selectedOptions.forEach(item => {
        a.push(item.name)
      })
      this.player.domicileAreaName = a.join('/')
      console.log(this.player.domicileAreaName, this.player.domicileAreaId)
    },
    onFinish({ selectedOptions }) {
      const a = []
      selectedOptions.forEach(item => {
        a.push(item.name)
      })
      this.player.domicileAreaName = a.join('/')
      this.showArea = false
    },
    getAreaTreeList() {
      getAreaTreeList().then(res => {
        if (res) {
          const { data } = res
          this.options = JSON.parse(data.list.list.replaceAll("'", '"')) || []
          this.getBMMatchTeamSignup()
        }
      })
    },
    checkPlayer(player) {
      let result = true
      const psfs = this.project.playerSignupFields && this.project.playerSignupFields.split('|') || []
      psfs.forEach(psf => {
        if (psf === 'IDCard' && (!player.certType || !player.IDCardNo)) {
          result = false
        } else if (psf === 'ID' && (!player.IDCardPhotoA || !player.IDCardPhotoB)) {
          result = false
        } else if (psf === 'guardian' && (!player.guardianName || !player.guardianMobile)) {
          result = false
        } else if (psf !== 'IDCard' && psf !== 'ID' && !player[psf]) {
          result = false
        }
      })
      return result
    },
    getBMMatchTeamSignup() {
      const params = {
        matchId: this.projectId,
      }
      if (this.teamId) {
        params.teamId = this.teamId
      }
      getBMMatchTeamSignup(params).then(res => {
        if (res) {
          const data = res.data || {}
          if (!data.team) {
            this.showButton = true
          } else if (data.team.isSubmit === 1 && data.team.auditStatus !== -1) {
            this.showButton = false
          } else if (data.team.auditStatus != 2) {
            this.showButton = data.team.auditStatus != 2
          }
          if (data.match.playerSignupFieldsLabel) {
            this.playerSignupFieldsLabel = {
              ...this.playerSignupFieldsLabel,
              ...data.match.playerSignupFieldsLabel,
            }
          }
          const project = data.match
          this.agreementList = data.agreement || []
          this.minDate = this.project.maxAge ? new Date(this.project.maxAge) : new Date(1990, 1, 1)
          this.maxDate = this.project.minAge ? new Date(this.project.minAge) : new Date()
          const psfs = project.playerSignupFields && project.playerSignupFields.split('|') || []
          const playerCheckboxes = {}
          this.jerseysSizeObj = {
            card: project.jerseysSizeAccessory,
            arr: project.jerseysSizeFields.split(',')
          }
          psfs.forEach(psf => {
            playerCheckboxes[psf] = true
          })
          this.playerCheckboxes = playerCheckboxes
          this.project = data.match
          const players = data.players || []
          if (players.length === 0) {
            for (let i = 0; i < this.project.teamMemberLimitCount; i++) {
              players.push({ certType: 1 })
            }
          }
          players.forEach(item => {
            item.showPlayerInfo = this.checkPlayer(item)
          })
          if (project.signupInstructionsOpen === 1 && Cookies.get(this.teamId) != this.teamId) {
            this.signupInstructions = project.signupInstructions
            this.signupInstructionsOpen = true
            let time = setInterval(() => {
              this.time--;
              if (this.time === 0) {
                clearInterval(time)
              }
            }, 1000);
          }
          this.players = players
        }
      })
    },
    getBMUnionMatch() {
      const params = {
        unionMatchId: this.unionMatchId
      }
      getBMUnionMatch(params).then(res => {
        if (res) {
          const { data } = res
          this.match = data.match || {}
        }
      })
    },
    getAge(birthday) {
      if (!birthday) return ''
      const now = new Date()
      const b = new Date(birthday)
      let age = now.getFullYear() - b.getFullYear()
      if (now.getMonth() < b.getMonth()) {
        age--
      } else if (now.getMonth() === b.getMonth() && now.getDate() < b.getDate) {
        age--
      }
      return `（${age}岁）`
    },
    confirmBirthdayTime(value) {
      this.player.bmBirthdayValue = DateUtil.parseDateTime(value, '{y}-{m}-{d}')
      this.player.bmBirthday = DateUtil.parseDateTime(value, '{y}-{m}-{d}T00:00:00+0800')
      this.showBirthday = false
    },
    cancelBirthdayTime() {
      this.showBirthday = false
    },
    getQiniuUploadToken() {
      getQiniuUploadToken({}).then(res => {
        this.qiniuToken = res.data.token
      })
    },
    uploadAvatar(file) {
      const formData = new FormData()
      formData.append('token', this.qiniuToken)
      formData.append('file', file.file)
      uploadImage(formData).then(res => {
        this.player.avatar = res.hash
      })
    },
    deleteAvatar() {
      const player = JSON.parse(JSON.stringify(this.player))
      player.avatar = ''
      player.avatarList = []
      this.player = player
    },
    uploadIDCardPhotoA(file) {
      const formData = new FormData()
      formData.append('token', this.qiniuToken)
      formData.append('file', file.file)
      uploadImage(formData).then(res => {
        this.player.IDCardPhotoA = res.hash
      })
    },
    deleteIDCardPhotoA() {
      const player = JSON.parse(JSON.stringify(this.player))
      player.IDCardPhotoA = ''
      player.IDCardPhotoAList = []
      this.player = player
    },
    uploadIDCardPhotoB(file) {
      const formData = new FormData()
      formData.append('token', this.qiniuToken)
      formData.append('file', file.file)
      uploadImage(formData).then(res => {
        this.player.IDCardPhotoB = res.hash
      })
    },
    deleteIDCardPhotoB() {
      const player = JSON.parse(JSON.stringify(this.player))
      player.IDCardPhotoB = ''
      player.IDCardPhotoBList = []
      this.player = player
    },
    uploadQualificationFile(file) {
      const formData = new FormData()
      formData.append('token', this.qiniuToken)
      formData.append('file', file.file)
      uploadImage(formData).then(res => {
        const player = JSON.parse(JSON.stringify(this.player))
        if (player.qualificationFile && player.qualificationFile.length > 0) {
          player.qualificationFile = player.qualificationFile + ',' + res.hash
        } else {
          player.qualificationFile = res.hash
        }
        const a = player.qualificationFile.split(',')
        player.qualificationFileList = []
        a.forEach(item => {
          player.qualificationFileList.push({ url: QNImageUtil.imageView(item), isImage: true, hash: item },)
        })
        this.player = player
      })
    },
    deleteQualificationFile() {
      const player = JSON.parse(JSON.stringify(this.player))
      const a = []
      player.qualificationFileList.forEach(item => {
        a.push(item.hash)
      })
      player.qualificationFile = a.join(',')
      this.player = player
    },
    uploadInsureFile(file) {
      const formData = new FormData()
      formData.append('token', this.qiniuToken)
      formData.append('file', file.file)
      uploadImage(formData).then(res => {
        const player = JSON.parse(JSON.stringify(this.player))
        if (player.insureFile && player.insureFile.length > 0) {
          player.insureFile = player.insureFile + ',' + res.hash
        } else {
          player.insureFile = res.hash
        }
        const a = player.insureFile.split(',') || []
        player.insureFileList = []
        a.forEach(item => {
          player.insureFileList.push({ url: QNImageUtil.imageView(item), isImage: true, hash: item },)
        })
        this.player = player
      })
    },
    deleteInsureFile() {
      const player = JSON.parse(JSON.stringify(this.player))
      const a = []
      player.insureFileList.forEach(item => {
        a.push(item.hash)
      })
      player.insureFile = a.join(',')
      this.player = player
    },
    checkMobile(value) {
      return RegExpr.checkMobile(value)
    },
    checkIDCardNo(value) {
      if (this.player.certType === 1) return RegExpr.isIdCard(value)
      return true
    },
    getFormatDate(date) {
      if (!date) return ''
      return DateUtil.parseDateTime(date, '{y}-{m}-{d}')
    },
    showPlayerFun(p, index) {
      this.index = index
      const player = JSON.parse(JSON.stringify(p)) || { certType: 1 }
      player.bmBirthdayValue = player.bmBirthday && this.getFormatDate(player.bmBirthday) || ''
      player.certTypeValue = player.certType && certTypeColumns[player.certType - 1] || '身份证'
      if (player.certTypeValue === '身份证') {
        player.certType = 1
      }
      player.avatarList = player.avatar && [{ url: QNImageUtil.imageView(player.avatar), isImage: true }] || []
      player.IDCardPhotoAList = player.IDCardPhotoA && [{ url: QNImageUtil.imageView(player.IDCardPhotoA), isImage: true, hash: player.IDCardPhotoA }] || []
      player.IDCardPhotoBList = player.IDCardPhotoB && [{ url: QNImageUtil.imageView(player.IDCardPhotoB), isImage: true, hash: player.IDCardPhotoB }] || []
      if (player.qualificationFile && player.qualificationFile.length > 0) {
        const a = player.qualificationFile.split(',') || []
        player.qualificationFileList = []
        a.forEach(item => {
          player.qualificationFileList.push({ url: QNImageUtil.imageView(item), isImage: true, hash: item })
        })
      } else {
        player.qualificationFileList = []
      }
      if (player.insureFile && player.insureFile.length > 0) {
        const a = player.insureFile.split(',') || []
        player.insureFileList = []
        a.forEach(item => {
          player.insureFileList.push({ url: QNImageUtil.imageView(item), isImage: true, hash: item })
        })
      } else {
        player.insureFileList = []
      }
      const a = []
      this.getAreaInfo(player.domicileAreaId, this.options, a)
      a.reverse()
      player.domicileAreaName = a.join('/')
      this.player = player
      this.currentDate = player.bmBirthday && new Date(player.bmBirthday) || ''
      this.showPlayer = true
      this.$nextTick(() => {
        const playerPopup = document.querySelector('.player-popup')
        playerPopup.scrollTop = 0
      })
    },
    getAreaInfo(areaId, options, a) {
      if (!areaId) return ''
      for (let i = 0; i < options.length; i++) {
        if (options[i].id === areaId) {
          a.push(options[i].name)
          return true
        } else if (options[i].kids) {
          const b = this.getAreaInfo(areaId, options[i].kids, a)
          if (b) {
            a.push(options[i].name)
            return true
          }
        }
      }
      return false
    },
    savePlayer() {
      if (this.playerCheckboxes.gender && (this.project.genderLimit != 0 && this.project.genderLimit != 3) && this.player.gender != this.project.genderLimit) {
        Toast({ type: 'fail', message: '性别异常' })
        return
      }
      if (this.playerCheckboxes.jerseysSize && !this.player.jerseysSize) {
        return Toast({ message: '请选择球衣尺码' })
      }
      this.$refs.playerForm.validate().then(() => {
        const players = JSON.parse(JSON.stringify(this.players))
        players[this.index] = JSON.parse(JSON.stringify(this.player))
        players.forEach(item => {
          item.showPlayerInfo = !!this.checkPlayer(item)
        })
        this.players = players
        this.showPlayer = false
      })
    },
    savePlayers() {
      if (this.project.isUseAgreement === 1 && this.agreementList.length > 0 && !this.allow) {
        Toast.fail('请先同意协议或条款')
        return
      }
      let checkInfo = true
      this.players.forEach(item => {
        if (!this.checkPlayer(item)) {
          checkInfo = false
        }
      })
      if (!checkInfo) {
        Toast.fail('请先完善球员信息')
        return
      }
      const players = JSON.parse(JSON.stringify(this.players)) || []
      players.forEach(item => {
        delete item.avatarList
        delete item.IDCardPhotoAList
        delete item.IDCardPhotoBList
        delete item.qualificationFileList
        delete item.insureFileList
        delete item.showPlayerInfo
        delete item.domicileAreaName
        delete item.bmBirthdayValue
        delete item.certTypeValue
      })
      const params = {
        matchId: this.projectId,
        players: JSON.stringify(players)
      }
      createBMMatchGroupTeam(params).then(res => {
        if (res) {
          this.showDialog = true
        }
      })
    },
    updatePlayers() {
      let checkInfo = true
      this.players.forEach(item => {
        if (!this.checkPlayer(item)) {
          checkInfo = false
        }
        if (!checkInfo) {
          Toast.fail('请先完善球员信息')
          return
        }
        const players = JSON.parse(JSON.stringify(this.players)) || []
        players.forEach(item => {
          delete item.avatarList
          delete item.IDCardPhotoAList
          delete item.IDCardPhotoBList
          delete item.qualificationFileList
          delete item.insureFileList
          delete item.showPlayerInfo
          delete item.domicileAreaName
          delete item.bmBirthdayValue
          delete item.certTypeValue
        })
        const params = {
          teamId: this.teamId,
          matchId: this.projectId,
          players: JSON.stringify(players)
        }
        updateBMMatchGroupTeam(params).then(res => {
          if (res) {
            this.showDialog = true
          }
        })
      })
    },
    goEntryList() {
      // this.$router.push('/entry-page/entry-list?unionMatchId=' + this.unionMatchId)
      this.$router.push({
        path: '/entry-page/team-operate',
        query: {
          unionMatchId: this.unionMatchId,
          matchId: this.projectId,
        }
      })
    },
    showCertTypeFun() {
      this.showCertType = true
    },
    onConfirmCertType(value) {
      this.player.certTypeValue = value
      const item = certTypeOption.find(i => i.label === value)
      this.player.certType = item.value
      this.showCertType = false
    },
    onCancelCertType() {
      this.showCertType = false
    },
    deletePlayer(index) {
      const players = JSON.parse(JSON.stringify(this.players))
      players[index] = {}
      players.forEach(item => {
        if (this.checkPlayer(item)) item.showPlayerInfo = true
        else item.showPlayerInfo = false
      })
      this.players = JSON.parse(JSON.stringify(players))
    }
  }
}
</script>

<style lang="scss">
.entry-info-more {
  min-height: 100vh;
  .title-info {
    border-radius: 5px;
    background: #F9F9F9;
    padding: 10px;
    margin: 12px;
    margin-bottom: 0;
    position: relative;
    .h1{
      font-size: 14px;
      color: #333333;
    }
    .h2{
      font-size: 16px;
      color: #333333;
      margin-top: 10px;
    }
    .item{
      font-size: 12px;
      color: #666666;
      margin-top: 10px;
    }
    .price{
      position: absolute;
      right: 11px;
      bottom: 14px;
      font-size: 12px;
      color: #999999;
      font-weight: 500;

      span{
        font-size: 20px;
        color: #CC3232;
      }
    }
  }

  .project {
    padding: 16px 12px 12px 12px;
    margin-bottom: 12px;
    background-color: #F8F8F8;
    border-radius: 4px;

    .top {
      display: flex;
      justify-content: space-between;

      .left {
        .group {
          overflow: hidden;
          text-overflow: ellipsis;
          -webkit-line-clamp: 2;
          display: -webkit-box;
          -webkit-box-orient: vertical;

          .entryType {
            background-color: #FF652A;
            color: #FFFFFF;
            border-radius: 2px;
            display: inline-block;
            height: 20px;
            width: 32px;
            line-height: 20px;
            font-size: 12px;
            text-align: center;
          }

          .group-name {
            font-size: 16px;
            height: 20px;
            color: #333333;
          }
        }

        .row {
          display: flex;
          padding: 5px 0;

          .base-box {
            width: 20px;
            height: 20px;
            background-color: #FBEFEA;
            border-radius: 2px;
            display: flex;
            justify-content: center;
            align-items: center;
          }

          .info {
            font-size: 12px;
            color: #8C8C8C;
          }

          .col {
            display: flex;
            height: 20px;
            width: 82px;
            line-height: 20px;

            .icon {
              width: 20px;
              height: 20px;
              text-align: center;
              line-height: 20px;
              background-color: #1565FC;
              font-size: 12px;
              font-weight: 500;
              color: #FFFFFF;
            }
          }
        }
      }

      .right {
        width: 40px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
    }

    .line {
      margin: 12px 0;
      height: 1px;
      background-color: #F3F3F3;
    }

    .bottom1 {
      .row {
        display: flex;
        justify-content: space-between;

        .base-box {
          width: 20px;
          height: 20px;
          background-color: #FBEFEA;
          border-radius: 2px;
          display: flex;
          justify-content: center;
          align-items: center;
        }

        .info {
          font-size: 12px;
          color: #8C8C8C;
        }

        .col {
          display: flex;
          height: 20px;
          line-height: 20px;

          .icon {
            width: 20px;
            height: 20px;
            text-align: center;
            line-height: 20px;
            background-color: #1565FC;
            font-size: 12px;
            font-weight: 500;
            color: #FFFFFF;
          }

          .price {
            height: 20px;
            width: 68px;
            text-align: center;
            line-height: 20px;
            background-color: #E5EDFF;
            font-size: 12px;
            font-weight: 500;
            color: #1565FC;
            border-radius: 0 3px 3px 0;
          }

          .num {
            font-size: 14px;
            color: #8C8C8C;
          }
        }
      }
    }
  }

  .player-list {
    .notice {
      height: 38px;
      padding: 0 12px;
      font-size: 11px;
      color: #191919;
      background-color: #FEF8F6;
      display: flex;
      align-items: center;
    }

    .players {
      padding: 16px;

      .player {
        padding: 16px 12px;
        margin-bottom: 12px;
        background-color: #FAFAFC;

        .row {
          display: flex;
          justify-content: space-between;
          align-items: center;

          .left {
            display: flex;
            align-items: center;

            .index {
              font-size: 16px;
              font-weight: 500;
              color: #333333;
              margin-right: 8px;
            }

            .true-name {
              font-size: 16px;
              font-weight: 500;
              color: #333333;
              margin-right: 8px;
            }
          }

          .info {
            font-size: 14px;
            color: #8C8C8C;
          }
        }
      }
    }
  }

  .bottom {
    position: fixed;
    bottom: 0;
    width: 100vw;
    padding: 14px 12px 12px 12px;
    box-sizing: border-box;
    background-color: #FFFFFF;
  }

  .wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    height: 100%;
  }

  .popup {
    .title {
      display: flex;
      align-items: center;
      font-weight: 500;
      font-size: 15px;
      color: #333333;
      padding: 25px 0 13px 0;
      margin: 0 16px;
      border-bottom: 0.5px #EEEEEE solid;

      .icon {
        width: 2px;
        height: 12px;
        background-color: #7CCD19;
        margin-right: 6px;
      }
    }
  }

  .delete-button {
    height: 100%;
    border-radius: 0 4px 4px 0;
  }
}

.agreement-top {
  background-color: #fff;
  padding: 12px 12px 0 12px;

  .agreement-title {
    text-align: center;
    font-weight: 600;
    font-size: 24px;
    margin-bottom: 4px;
  }

  .hint {
    text-align: center;
    font-size: 16px;
    color: #8C8C8C;
  }
}

.notice {
  .notice-title {
    text-align: center;
    font-size: 16px;
    padding: 12px 0;
    // border-bottom: 1px solid #f3f3f3;
  }

  .info {
    padding: 12px;
    white-space: pre-wrap;
  }

  .close {
    text-align: center;
    color: #576B95;
    // border-top: 1px solid #f3f3f3;
    padding: 12px 0;
  }

  .disabled {
    color: #999 !important;
  }
}

#agreement {
  padding: 0 24px 12px 24px;

  .wscnph {
    width: 100%;
  }
}
</style>
